import { getAuth } from "firebase/auth";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { apiClient, MyDocumentsLoaderResult } from "~/services/apiClient";
import { FileData } from "~/types";

export const MyDocumentPageLoader = async ({ request }: LoaderFunctionArgs) => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) redirect("/signup");

  const response = await apiClient.loader<MyDocumentsLoaderResult>("my-documents");

  if (!response.success || !response.data) {
    return { fileList: null };
  }

  return { fileList: response.data.fileList };
};

export type MyDocumentPageLoaderType = {
  fileList: FileData[] | null;
};
